export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'fileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '文档名称',
    slots: {
      default: 'showFiles'
    }
  }
]
